// ─── PROFILE (single source of truth for identity + contact) ──────────────────
// Everything about who Usama is and how to reach him lives here. The AI agent
// persona, résumé header, contact page, and social links all derive from it.
export const profile = {
  name: "Usama Masood",
  title: "Senior Software Engineer",
  bio: "Senior Software Engineer with 5+ years shipping full-stack products and AI systems across fintech, aviation, logistics, and healthcare. Currently leading AI agent delivery at Lua AI, with production WhatsApp agents live in five countries at 95%+ on daily QA audits. Strengths: test-driven development and release quality, platform engineering on high-traffic systems, and leading cross-functional teams and client engagements end to end.",
  email: "usamamasood28@gmail.com",
  phone: "+923150449133",
  portfolio: "https://usama-masood.netlify.app",
  linkedin: {
    handle: "usamamasood28",
    url: "https://www.linkedin.com/in/usamamasood28",
  },
  github: {
    handle: "usamamasood01",
    url: "https://github.com/usamamasood01",
  },
  discord: {
    url: "https://discordapp.com/users/971462776075739136",
  },
};

// AI agent persona (src/index.ts).
export const personalInfo = {
  name: profile.name,
  title: profile.title,
  email: profile.email,
  linkedin: profile.linkedin.url,
  github: profile.github.url,
  portfolio: profile.portfolio,
  bio: profile.bio,
};

// Résumé header (components/resume/Header.jsx) and contact page (views/Contact.jsx).
export const header = {
  name: profile.name,
  title: profile.title,
  links: {
    email: profile.email,
    tel: profile.phone,
    portfolio: profile.portfolio,
    linkedIn: profile.linkedin.handle,
  },
};

// Contact page social icons (views/Contact.jsx). `image` is the asset base; the
// view appends `.svg` / `-active.svg` for the hover state.
export const allSocialLinks = [
  {
    title: "LinkedIn",
    image: "/assets/linkedin",
    hover: false,
    url: profile.linkedin.url,
  },
  {
    title: "Github",
    image: "/assets/github",
    hover: false,
    url: profile.github.url,
  },
  {
    title: "Discord",
    image: "/assets/about/discord",
    hover: false,
    url: profile.discord.url,
  },
];

// Résumé PDF filename, e.g. "Usama Masood (usamamasood28@gmail.com) - Frontend.pdf".
export const resumeFileName = (suffix = "") =>
  `${profile.name} (${profile.email})${suffix}.pdf`;
